import { a as __rest, _ as _assign } from './tslib.es6-c6da0ae6.js';
import { jsx } from 'react/jsx-runtime';
import dompurify from 'isomorphic-dompurify';

var CONFIG = {
  ADD_ATTR: ['target']
};
dompurify.addHook('afterSanitizeAttributes', function (node) {
  if ('target' in node) {
    node.setAttribute('rel', 'noopener');
  }
});
function SanitizeHtml(_a) {
  var Component = _a.tag,
    html = _a.html,
    config = _a.config,
    props = __rest(_a, ["tag", "html", "config"]);
  return jsx(Component, _assign({
    dangerouslySetInnerHTML: {
      __html: dompurify.sanitize(html, _assign(_assign({}, CONFIG), config))
    }
  }, props));
}

export { SanitizeHtml as S };
//# sourceMappingURL=SanitizeHtml-299f5620.js.map
